import Vue from 'vue'
import App from './App.vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import VueClipBoard from 'vue-clipboard2'
// import TDesign from 'tdesign-vue'
// import 'tdesign-vue/es/style/index.css'
import router from './router'

Vue.use(Element)
Vue.use(VueClipBoard)
// Vue.use(TDesign)
Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
